var _rect, _rect2, _path, _path2, _path3, _path4, _g, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlooLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.304453,
    y: 0.913828,
    width: 47.3911,
    height: 22.172,
    rx: 11.086,
    fill: "#171717"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.304453,
    y: 0.913828,
    width: 47.3911,
    height: 22.172,
    rx: 11.086,
    stroke: "url(#paint0_linear_3962_26937)",
    strokeWidth: 0.608907
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9143 5.48047H15.582V15.2823H16.9143V5.48047Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5942 14.2285C20.3412 14.2285 19.441 13.2327 19.441 11.995C19.441 10.7929 20.334 9.80422 21.5942 9.80422C22.8257 9.80422 23.7042 10.8 23.7042 11.995C23.7042 13.2327 22.8257 14.2285 21.5942 14.2285ZM21.5942 8.58789C19.5994 8.58789 18.1016 10.1172 18.1016 11.995C18.1016 13.9013 19.5922 15.4449 21.5942 15.4449C23.5602 15.4449 25.0437 13.9013 25.0437 11.995C25.0437 10.1172 23.5674 8.58789 21.5942 8.58789Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4302 14.2285C28.1771 14.2285 27.277 13.2327 27.277 11.995C27.277 10.7929 28.1699 9.80422 29.4302 9.80422C30.6616 9.80422 31.5402 10.8 31.5402 11.995C31.5402 13.2327 30.6616 14.2285 29.4302 14.2285ZM29.4302 8.58789C27.4354 8.58789 25.9375 10.1172 25.9375 11.995C25.9375 13.9013 27.4282 15.4449 29.4302 15.4449C31.3961 15.4449 32.8796 13.9013 32.8796 11.995C32.8796 10.1172 31.4033 8.58789 29.4302 8.58789Z",
    fill: "url(#paint1_linear_3962_26937)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30664 11.995C7.30664 13.9013 8.80453 15.4449 10.7993 15.4449C11.6131 15.4449 12.3332 15.1817 12.9093 14.7407V15.2173C12.9093 16.7466 12.1532 17.2872 10.7705 17.2872L10.7849 18.5177C12.4988 18.5177 14.2344 17.9344 14.2344 14.9185V8.6448H12.9741L12.9165 9.28497C12.3404 8.85107 11.6131 8.58789 10.8065 8.58789C8.80453 8.58789 7.30664 10.1172 7.30664 11.995ZM10.7993 14.2285C9.53906 14.2285 8.6461 13.2327 8.6461 11.995C8.6461 10.7929 9.53906 9.80422 10.7993 9.80422C12.0307 9.80422 12.9093 10.8001 12.9093 11.995C12.9093 13.2398 12.0307 14.2285 10.7993 14.2285Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3962_26937)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9998 8.61549C37.7956 8.57939 37.5852 8.56055 37.3704 8.56055C37.1293 8.56055 36.8938 8.58429 36.6663 8.62951V11.3766H33.91C33.8716 11.5804 33.8516 11.7906 33.8516 12.0053C33.8516 12.2468 33.877 12.4825 33.9253 12.71H36.6663V15.3811C36.8938 15.4263 37.1293 15.45 37.3704 15.45C37.5852 15.45 37.7956 15.4312 37.9998 15.3951V12.71H40.8155C40.8638 12.4825 40.8892 12.2468 40.8892 12.0053C40.8892 11.7906 40.8691 11.5804 40.8307 11.3766H37.9998V8.61549Z",
    fill: "url(#paint2_linear_3962_26937)",
    fillOpacity: 0.56
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9998 8.6448C37.7956 8.60869 37.5852 8.58984 37.3704 8.58984C37.1293 8.58984 36.8938 8.61358 36.6664 8.6588V11.4059H33.91C33.8716 11.6097 33.8516 11.8199 33.8516 12.0346C33.8516 12.2761 33.877 12.5118 33.9253 12.7393H36.6664V15.4104C36.8938 15.4556 37.1293 15.4793 37.3704 15.4793C37.5852 15.4793 37.7956 15.4605 37.9998 15.4244V12.7393H40.8155C40.8638 12.5118 40.8892 12.2761 40.8892 12.0346C40.8892 11.8199 40.8691 11.6097 40.8307 11.4059H37.9998V8.6448Z",
    fill: "url(#paint3_linear_3962_26937)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3962_26937",
    x: 31.3328,
    y: 6.04176,
    width: 12.0747,
    height: 11.9262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25939,
    result: "effect1_foregroundBlur_3962_26937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3962_26937",
    x1: 1.05966e-8,
    y1: 13.092,
    x2: 48.1036,
    y2: 12.1786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67C586"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3962_26937",
    x1: 30.9389,
    y1: 12.5174,
    x2: 33.828,
    y2: 12.5174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67C586"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3962_26937",
    x1: 33.8516,
    y1: 12.1905,
    x2: 40.8892,
    y2: 12.1905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3962_26937",
    x1: 33.8516,
    y1: 12.2198,
    x2: 40.8892,
    y2: 12.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#67C586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5F3FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlooLogo);
export default __webpack_public_path__ + "static/media/gloo-logo.0f47d62142c8d9a6940f5366c8e670da.svg";
export { ForwardRef as ReactComponent };